import React from "react"
import { T, always, cond, pathOr } from "ramda"
import { Theme } from "@pga/pga-component-library"
import moment from "moment"

import { PDRTracking } from "./ProgressBar"
import { Condition, TotalWrapper, Wrapper } from "./Styles/Shared.styles"
import { formatDate } from "../../utils/formatter"
import AlertBox from "./AlertBox"

const NewPDRInfo = ({ currentPerson }) => {
  const { firstName, pdrRequirements } = currentPerson
  const { cycleCode, cycleEndsOn } = pathOr(
    {},
    ["pdrRequirements"],
    currentPerson,
  )
  const requirements = pathOr([], ["requirements"], pdrRequirements)
  const status = pathOr(null, ["status"], pdrRequirements)
  const fourMonthsBeforeEndOfCycle = cycleEndsOn
    ? moment(cycleEndsOn).subtract(4, "months").toDate()
    : null
  const today = moment().startOf("day")

  const greeting = cond([
    [
      status => status === "requirements_met",
      always(
        `Congrats, ${firstName}! You've met your PDR requirements for this cycle.`,
      ),
    ],
    [
      T,
      always('Earn more credits by clicking the "Earn Credits" button below.'),
    ],
  ])

  const message = cond([
    [
      status => status === "recovering",
      always(
        `Report all recovery credits for Cycle ${cycleCode} by ${formatDate(cycleEndsOn, "MMMM DD")} to avoid being dropped from active Membership rolls.`,
      ),
    ],
    [
      status => status === "requirements_not_met",
      always(
        `Report credits earned in PDR Cycle ${cycleCode} by ${formatDate(cycleEndsOn, "MMMM DD")} to avoid reclassification to Class F.`,
      ),
    ],
    [T, always(null)],
  ])

  return (
    <>
      <TotalWrapper>{greeting(status)}</TotalWrapper>
      {moment(fourMonthsBeforeEndOfCycle).isBefore(today) && (
        <AlertBox>{message(status)}</AlertBox>
      )}
      <div>
        <Wrapper>
          {requirements.map((pdr, i) => (
            <PDRTracking
              completed={pdr.earned}
              total={pdr.totalRequirement}
              label={pdr.label}
              color={
                [
                  Theme.colors.lightBlue,
                  Theme.colors.gold,
                  Theme.colors.primary,
                ][i]
              }
              recovery={pdr.recoveryRemaining}
              totalDeficit={pdr.recoveryRemaining}
              key={i}
            />
          ))}
        </Wrapper>
        <Condition>
          Requirements in all categories must be met to maintain membership.
        </Condition>
      </div>
    </>
  )
}

export default NewPDRInfo
